import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { StateType } from 'typesafe-actions';
import { bookDirectReducer } from '../features/bookDirect';
import { addressesReducer } from '../features/addresses';
import { bookMultiReducer } from '../features/bookMulti';
import { bookRecurringReducer } from '../features/bookRecurring';
import { ordersReducer } from '../features/orders';

const rootReducer = combineReducers({
  router: routerReducer,
  bookDirect: bookDirectReducer,
  bookMulti: bookMultiReducer,
  bookRecurring: bookRecurringReducer,
  addresses: addressesReducer,
  orders: ordersReducer
});

export type RootState = StateType<typeof rootReducer>;

export default rootReducer;
